import { useUserInfo } from '@/features/space-user';
import AppLayout from '@/legacy/layouts/AppLayout';
import { useEffect } from 'react';
import i18n from '@/legacy/i18n';
import { usePermissions } from '@/features/access-control/api';
import ErrorPage from '../pages/ErrorPage';
import { useSectionAccess } from '../analytics';
import { usePrefetchPosTable } from '@/legacy/features/pointsOfSale/hooks';
import { usePrefetchTagsTable } from '@/legacy/features/tags/hooks';
import { usePrefetchUsersTable } from '@/legacy/features/users/hooks';
import { SkeletonTheme } from '@/shared/ui/skeleton';
import AppShellSkeleton from '@/app/pages/AppShellSkeleton';
import { useAutoImpersonate } from '@/features/auth/hooks/useAutoImpersonate';
import { useIsSuperUser } from '@/features/access-control';

export function AppGate() {
	const isSuperUser = useIsSuperUser();
	const { data: userInfo, isLoading: isLoadingUser, isSuccess } = useUserInfo();

	useSectionAccess();

	useEffect(() => {
		if (isSuccess && userInfo) {
			if (userInfo.languageAbbreviation) {
				i18n.changeLanguage(userInfo.languageAbbreviation);
			}
		}
	}, [isSuccess, userInfo]);

	const needsImpersonation = !isLoadingUser && isSuperUser && !userInfo?.companyId;

	const { isLoading: isLoadingPermissions, isError: isPermissionsError } = usePermissions({
		enabled: !needsImpersonation,
	});

	const { isPending: isImpersonating, isError: isImpersonationError } = useAutoImpersonate();

	usePrefetchPosTable();
	usePrefetchTagsTable();
	usePrefetchUsersTable();

	return (
		<SkeletonTheme
			baseColor='var(--color-fill-tertiary)'
			highlightColor='var(--color-fill-nude)'
		>
			{isPermissionsError ? (
				<ErrorPage />
			) : isLoadingUser || isLoadingPermissions ? (
				<AppShellSkeleton />
			) : needsImpersonation && isImpersonationError ? (
				<ErrorPage onReset={() => window.location.reload()} />
			) : needsImpersonation || isImpersonating ? (
				<AppShellSkeleton />
			) : (
				<AppLayout />
			)}
		</SkeletonTheme>
	);
}
